export const NAMESPACE = 'fixtures';
